import { ZEGOCLOUD_APP_ID } from 'constants';
import useZegoCloudStore from 'store/zegoCloud';
import { ZIM } from 'zego-zim-web';

export const getZimUser = () => {
	const gimUser = sessionStorage.getItem('zim_user') || null;
	return gimUser;
};

export const loginZIM = async (userID: any, userName: any, token: any) => {
	let zimInstance: any;

	// Check if ZIM SDK has been created
	if (!ZIM.getInstance()) {
		// Initialize ZIM SDK
		zimInstance = ZIM.create({
			appID: Number(ZEGOCLOUD_APP_ID), // Replace with your actual App ID
		});
	} else {
		zimInstance = ZIM.getInstance();
	}
	try {
		// Login with user credentials
		await zimInstance.login(
			{
				userID: userID.toString(),
				userName: userName,
			},
			token,
		);

		return { userID, userName };
	} catch (error) {
		console.error('Login Error:', error);
	}
};

// Logout function
export const logoutZIM = async () => {
	const { zpInstance }: any = useZegoCloudStore.getState();
	try {
		await zpInstance?.logout();
	} catch (error) {
		console.error('Logout Error:', error);
	}
};
